/**
 * Coupon Input Component
 *
 * Provides a simple, controlled input field for coupon codes.
 * The parent component is responsible for handling validation and application logic.
 */

import React from "react";
import styles from "./AffiliateReferrals.module.css";

interface CouponInputProps {
  code: string;
  onCodeChange: (code: string) => void;
  disabled?: boolean;
  placeholder?: string;
  isValidating?: boolean;
  error?: boolean;
}

const CouponInput: React.FC<CouponInputProps> = ({
  code,
  onCodeChange,
  disabled = false,
  placeholder = "Enter coupon code",
  isValidating = false,
  error = false,
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onCodeChange(e.target.value.toUpperCase());
  };

  return (
    <div className={styles.couponInputContainer}>
      <input
        type="text"
        value={code}
        onChange={handleInputChange}
        placeholder={placeholder}
        disabled={disabled || isValidating}
        className={`${styles.couponInput} ${error ? styles.errorInput : ""}`}
        maxLength={50}
      />

      {isValidating && (
        <div className={styles.loadingSpinner}>
          <div className={styles.spinner} />
        </div>
      )}
    </div>
  );
};

export default CouponInput;



